import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer, PURGE } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "redux";

import themeSettingSlice from "./themeSettingSlice";
import sidebarSlice from "./sidebarSlice";
import userSlice from "./userSlice";
import dashboardReducer from "./dashboardSlice";
import automationReducer from "./automations/slice";
import leadsInQueueReducer from "./leads-queue/slice";
import liveCallReducer from "./live-call/slice";
import recruitmentReducer from "./recruitment/slice";
import projectsReducer from "./projects/slice";
import adminLeavesReducer from "./admin-leaves/slice";
import emailTemplatesReducer from "./email-templates/slice";

const persistConfig = {
  key: "root",
  storage, // using localStorage for persistence
  whitelist: ["themeSetting", "sidebarSlice", "user", "country"], // Only persist specific slices
};

const dashboardPersistConfig = {
  key: "dashboard",
  storage,
  blacklist: [
    "backendData",
    "isLoading",
    "isEditMode",
    "topMetrics",
    "cards",
    "companies",
    "selectedCompany",
    "isLoadingCompanies",
    "employees",
    "departments",
    "isSaving",
    "drafts",
  ],
};


const appReducer = combineReducers({
  themeSetting: themeSettingSlice,
  sidebarSlice: sidebarSlice,
  user: userSlice,
  dashboard: persistReducer(dashboardPersistConfig, dashboardReducer),
  automations: automationReducer,
  leadsQueue: leadsInQueueReducer,
  liveCall: liveCallReducer,
  recruitment: recruitmentReducer,
  projects: projectsReducer,
  adminLeaves: adminLeavesReducer,
  emailTemplates: emailTemplatesReducer,
});

const rootReducer = (state: any, action: any) => {
  if (action.type === "user/logout") {
    storage.removeItem("persist:root");
    storage.removeItem("persist:dashboard");
    state = undefined;
  }
  return appReducer(state, action);
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE", PURGE],
      },
    }),
});

const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export { store, persistor };
